import { render, staticRenderFns } from "./CampusImage.vue?vue&type=template&id=44c7eb0b&scoped=true&"
import script from "./CampusImage.vue?vue&type=script&lang=js&"
export * from "./CampusImage.vue?vue&type=script&lang=js&"
import style0 from "./CampusImage.vue?vue&type=style&index=0&id=44c7eb0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c7eb0b",
  null
  
)

export default component.exports